// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import EntitySelectorDTO from './EntitySelectorDTO';

interface AdminOiePenaltyDTO extends EntitySelectorDTO { 
  penaltyId: string | null;
  penaltyAmount: number | null;
  penaltyPaidDate: moment.Moment | string | null;
  penaltyIssuedDate: moment.Moment | string | null;
  penaltyDueDate: moment.Moment | string | null;
  penaltyWaiverDate: moment.Moment | string | null;
  waiverRequested: boolean;
  penaltyWaiverReason: string | null;
  expendId: string | null;
  penaltyDescription: string | null;
  waiverAmount: number | null;
  waiverDenied: boolean | null;
}
const AdminOiePenaltyDTO = {
  create: (initValues?: Partial<AdminOiePenaltyDTO> | Record<string, unknown> | null) => {
    return Object.assign(EntitySelectorDTO.create(),
    {
      penaltyId: "00000000-0000-0000-0000-000000000000",
      penaltyAmount: null,
      penaltyPaidDate: null,
      penaltyIssuedDate: null,
      penaltyDueDate: null,
      penaltyWaiverDate: null,
      waiverRequested: false,
      penaltyWaiverReason: null,
      expendId: "00000000-0000-0000-0000-000000000000",
      penaltyDescription: null,
      waiverAmount: null,
      waiverDenied: null,
    },
    initValues);
  }
};

export default AdminOiePenaltyDTO;